/**
 * @generated SignedSource<<767eb534e1db95e8c41801ad1fd845ad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NotificationMenu_viewer$data = {
  readonly backendId: number | null;
  readonly unseenNotifications: number | null;
  readonly recentNotifications: ReadonlyArray<{
    readonly id: string;
    readonly countId: number | null;
    readonly publisherPersonId: string;
    readonly subscriberPersonId: string;
    readonly publisherAction: string | null;
    readonly entityType: string | null;
    readonly entityId: number | null;
    readonly params: string | null;
    readonly createdAt: string | null;
    readonly read: boolean | null;
  } | null> | null;
  readonly notifyInAppOnProjectStatusChange: boolean | null;
  readonly notifyInAppOnPersonJoin: boolean | null;
  readonly notifyInAppOnAssignedProject: boolean | null;
  readonly notifyInAppOnProjectDeadline: boolean | null;
  readonly notifyInAppOnAssignedTask: boolean | null;
  readonly notifyInAppOnAssignedTaskUpdate: boolean | null;
  readonly notifyInAppOnTaskDeadline: boolean | null;
  readonly notifyInAppOnMention: boolean | null;
  readonly notifyInAppOnTaskDescriptionChange: boolean | null;
  readonly notifyInAppOnTaskTitleChange: boolean | null;
  readonly notifyInAppOnTaskEstimateChange: boolean | null;
  readonly notifyInAppOnTaskStartDateChange: boolean | null;
  readonly notifyInAppOnTaskEndDateChange: boolean | null;
  readonly notifyInAppOnTaskSprintChange: boolean | null;
  readonly notifyInAppOnTaskPhaseChange: boolean | null;
  readonly notifyInAppOnTaskStatusColumnChange: boolean | null;
  readonly notifyInAppOnTaskProjectChange: boolean | null;
  readonly notifyInAppOnTaskSubtaskChange: boolean | null;
  readonly notifyInAppOnTaskSubtaskEstimateChange: boolean | null;
  readonly notifyInAppOnTaskCommentChange: boolean | null;
  readonly notifyInAppOnTaskFileChange: boolean | null;
  readonly notifyInAppOnTaskBugChange: boolean | null;
  readonly notifyInAppOnTaskBlockedChange: boolean | null;
  readonly notifyInAppOnTaskRepeatingChange: boolean | null;
  readonly notifyInAppOnTimeOffManager: boolean | null;
  readonly notifyInAppOnTimeOffOwner: boolean | null;
  readonly notifyInAppOnInvoiceDueDate: boolean | null;
  readonly notifyInAppOnInvoiceOverdue: boolean | null;
  readonly notifyInAppOnInvoiceDaysOverdue: boolean | null;
  readonly notifyInAppOnInvoiceCreatedOrDeleted: boolean | null;
  readonly notifyInAppOnInvoiceStatusChange: boolean | null;
  readonly notifyInAppOnInvoiceDateReached: boolean | null;
  readonly notifyInAppOnInvoicePayment: boolean | null;
  readonly notifyInAppOnInvoiceDateChanged: boolean | null;
  readonly notifyInAppOnInvoiceDueDateChanged: boolean | null;
  readonly company: {
    readonly allPersons: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly fullName: string | null;
          readonly profilePictureId: string | null;
          readonly profilePictureDefaultId: number | null;
          readonly initials: string | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
  readonly projects: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly companyProjectId: number | null;
        readonly customProjectId: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"DeprecatedProjectIndicatorJS_project">;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "NotificationMenu_viewer";
};
export type NotificationMenu_viewer$key = {
  readonly " $data"?: NotificationMenu_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NotificationMenu_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotificationMenu_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "backendId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unseenNotifications",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PersonNotification",
      "kind": "LinkedField",
      "name": "recentNotifications",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "countId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publisherPersonId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subscriberPersonId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publisherAction",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "params",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "read",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnProjectStatusChange",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnPersonJoin",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnAssignedProject",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnProjectDeadline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnAssignedTask",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnAssignedTaskUpdate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnTaskDeadline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnMention",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnTaskDescriptionChange",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnTaskTitleChange",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnTaskEstimateChange",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnTaskStartDateChange",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnTaskEndDateChange",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnTaskSprintChange",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnTaskPhaseChange",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnTaskStatusColumnChange",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnTaskProjectChange",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnTaskSubtaskChange",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnTaskSubtaskEstimateChange",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnTaskCommentChange",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnTaskFileChange",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnTaskBugChange",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnTaskBlockedChange",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnTaskRepeatingChange",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnTimeOffManager",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnTimeOffOwner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnInvoiceDueDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnInvoiceOverdue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnInvoiceDaysOverdue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnInvoiceCreatedOrDeleted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnInvoiceStatusChange",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnInvoiceDateReached",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnInvoicePayment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnInvoiceDateChanged",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyInAppOnInvoiceDueDateChanged",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 48714
            },
            {
              "kind": "Literal",
              "name": "includeSystem",
              "value": true
            }
          ],
          "concreteType": "PersonTypeConnection",
          "kind": "LinkedField",
          "name": "allPersons",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PersonTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Person",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fullName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "profilePictureId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "profilePictureDefaultId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "initials",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "allPersons(first:48714,includeSystem:true)"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 10000
        }
      ],
      "concreteType": "ProjectTypeConnection",
      "kind": "LinkedField",
      "name": "projects",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "companyProjectId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customProjectId",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "DeprecatedProjectIndicatorJS_project"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "projects(first:10000)"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "4a650d27243bfd36b5387997b1dd97e3";

export default node;
